import {useEffect, useRef, useState} from 'react';

export const useInView = (options?: IntersectionObserverInit | undefined) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  const callbackFunction = (entries: IntersectionObserverEntry[]) => {
    const [entry] = entries;
    setInView(entry.isIntersecting);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);
    const refCurrent = ref.current;
    if (refCurrent) {
      observer.observe(refCurrent);
    }
    return () => {
      if (refCurrent) {
        observer.unobserve(refCurrent);
      }
    };
  }, [ref, options]);

  return {ref, inView};
};
